angular.module('payments.components.paymentFormCybersource', [])
    .component('paymentFormCybersource', {
        bindings: {
            resolve: '<',
            modalInstance: '<',
        },
        templateUrl: '/Scripts/app/payments/components/payment-form-cybersource.template.html',
        controller: class PaymentFormCyberSourceCtrl {

            $window: any;
            $http: any;
            resolve: any;
            modalInstance: any;

            config: any;
            paymentFormSubmitted: boolean;
            sidebarObserver: MutationObserver | null = null;
            isSidebarActive: boolean = false;

            loading: boolean = false;
            error: string | null = null;
            clientLibraryUrl: string | null = null;
            clientLibraryIntegrity: string | null = null;
            jwt: string | null = null;
            completeToken: any = null;

            static $inject = ['$window', '$http'];

            constructor($window: any, $http: any) {
                this.$window = $window;
                this.$http = $http;
            }

            $onInit() {
                this.config = this.resolve.config;
                this.paymentFormSubmitted = false;
                this.fetchCaptureContext();
            }

            fetchCaptureContext = () => {
                this.loading = true;
                this.error = null;

                const urlBase = this.$window.EveryBuddy.CoreAPI;
                const totalAmount = this.config.paymentAmount;

                this.$http
                    .get(`${urlBase}/api/capture-context?totalAmount=${encodeURIComponent(totalAmount)}`)
                    .then((res: any) => {
                        if (res.data.errorMessage) {
                            this.error = res.data.errorMessage;
                            this.loading = false;
                            return;
                        }
                        const decoded = this.decodeJWT(res.data.jwt);
                        const ctxNode = decoded.ctx[0].data;

                        if (ctxNode == null) {
                            this.error = 'Invalid JWT received';
                            this.loading = false;
                            return;
                        }

                        this.clientLibraryUrl = ctxNode.clientLibrary;
                        this.clientLibraryIntegrity = ctxNode.clientLibraryIntegrity;
                        this.jwt = res.data.jwt;

                        this.flexSetup();
                        setTimeout(() => {
                            this.loading = false;
                        }, 2000);
                    })
                    .catch((err: any) => {
                        this.error = (err && (err.data?.error || err.message)) || 'Request failed';
                        console.warn('Error load capture context:', this.error);
                        this.loading = false;
                    });
            };

            flexSetup = () => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.src = this.clientLibraryUrl ?? '';
                script.integrity = this.clientLibraryIntegrity ?? '';
                script.crossOrigin = "anonymous";

                script.onload = async () => {
                    await this.flexSetupFunc();
                }

                document.head.appendChild(script);
            };

            flexSetupFunc = async () => {
                const AcceptFn = (window as any).Accept;
                if (typeof AcceptFn !== 'function') {
                    this.error = 'Payment library failed to load';
                    return;
                }

                try {
                    const accept = await AcceptFn(this.jwt);
                    const up = await accept.unifiedPayments(true);

                    if (up.sidebar) {
                        const isCybersourceIframe = (node: Node): boolean => {
                            if (node.nodeType !== 1 || (node as HTMLElement).tagName !== 'IFRAME') {
                                return false;
                            }
                            const iframe = node as HTMLIFrameElement;
                            return iframe.style.position === 'fixed' || iframe.src?.includes('cybersource') || false;
                        };

                        this.sidebarObserver = new MutationObserver((mutations) => {
                            for (const mutation of mutations) {
                                const addedCybersourceIframe = Array.from(mutation.addedNodes).some(isCybersourceIframe);
                                const removedCybersourceIframe = Array.from(mutation.removedNodes).some(isCybersourceIframe);

                                if (addedCybersourceIframe) {
                                    this.isSidebarActive = true;
                                } else if (removedCybersourceIframe) {
                                    this.isSidebarActive = false;
                                }
                            }
                        });

                        this.sidebarObserver.observe(document.body, { childList: true, subtree: false });
                    }

                    this.completeToken = await up.show({
                        containers: {
                            paymentSelection: "#buttonPaymentListContainer"
                        }
                    });

                    const completeResponse = await up.complete(this.completeToken);

                    this.returnToken(completeResponse);
                }
                catch (error) {
                    this.error = 'Payment failed: ' + JSON.stringify(error, null, 2);
                }
            };

            returnToken(token: string) {
                this.modalInstance.close(token);
            }

            cancel() {
                if (this.isCancelDisabled()) {
                    return;
                }
                this.modalInstance.dismiss(this.paymentFormSubmitted);
            }

            isCancelDisabled(): boolean {
                if (this.error !== null) {
                    return this.isSidebarActive;
                }
                return this.isSidebarActive || this.completeToken !== null;
            }

            $onDestroy() {
                if (this.sidebarObserver) {
                    this.sidebarObserver.disconnect();
                    this.sidebarObserver = null;
                }
            }

            decodeJWT = (token: string): any => {
                try {
                    const parts = token.split('.');
                    if (parts.length < 2) return null;
                    const base64Url = parts[1];
                    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    const padded = base64 + '==='.slice((base64.length + 3) % 4);
                    const json = atob(padded);
                    try {
                        return JSON.parse(decodeURIComponent(Array.prototype.map.call(json, (c: string) =>
                            '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                        ).join('')));
                    } catch (_) {
                        return JSON.parse(json);
                    }
                } catch (_) {
                    return null;
                }
            }
        }
    });
